import { FaGlobe, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import hospitalLogoWhite from '../assets/logo/mukti-logo-white.png';
import { Link } from 'react-router-dom';

export const PrintLayout = ({ className, billInfo, table, summary, note, footer, title = 'Pathology Bill' }) => {
  return (
    <div className={`${className} hidden`}>
      <style>
        {`
          @media print {
            @page {
              size: A4;
              margin: 0;
            }
            body * {
              visibility: hidden;
            }
            .print-wrapper,
            .print-wrapper * {
              visibility: hidden;
            }
            .${className}, .${className} * {
              visibility: visible;
            }
            .footer-area, .footer-shape, th {
              -webkit-print-color-adjust: exact !important;
              color-adjust: exact !important;
            }
            .print-container {
              position: absolute;
              top: 0; left: 0; right: 0; bottom: 0;
            }
            .print-bg-force {
              -webkit-print-color-adjust: exact !important;
              color-adjust: exact !important;
            }
            .header-gradient {
              background: linear-gradient(120deg, #323290, #009650) !important;
            }
            .footer-shape {
              content: '';
              position: absolute;
              top: 0;
              right: 0;
              width: 150px;
              height: 100%;
              background-color: #009650 !important;
              clip-path: polygon(25% 0%, 100% 0%, 100% 100%, 0% 100%);
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 20px;
              font-size: 12pt;
            }
            th, td {
              border: 1px solid #ddd;
              padding: 8px;
              text-align: left;
            }
            th {
              background-color: #323290 !important;
              color: #fff !important;
              font-weight: bold;
            }
            tbody tr:nth-child(even) { background-color: #f7f9ff; }
            td:last-child, th:last-child { text-align: right; }
            
            .summary-container {
              background: #f7f9ff;
              border: 1px solid #e0e5f5;
              padding: 5px;
              border-radius: 8px;
            }
            .summary-container div {
              display: flex;
              justify-content: space-between;
              padding: 8px 10px;
              border-bottom: 1px dashed #ccc;
            }
            .summary-container div:last-child {
              font-weight: bold;
              font-size: 12pt;
              color: #009650;
              border-top: 2px solid #009650;
              border-bottom: none;
              margin-top: 5px;
            }
            .print-container::before {
              content: "Mukti Hospital";
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%) rotate(-45deg);
              font-size: 100pt;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.04);
              pointer-events: none;
              z-index: -1;
              white-space: nowrap;
            }
            .print-container .note-box {
              border-left: 4px solid #323290;
              padding: 10px;
              font-size: 8pt;
              margin-top: 20px;
              color: #555;
            }
        }
        `}
      </style>
      <div className="print-container font-roboto text-gray-800">
        
        {/* Header */}
        <div className="absolute top-0 left-0 right-0 z-50 flex items-center justify-between p-3 px-[20mm] text-white header-gradient print-bg-force">
          <div className="logo-container">
            <img src={hospitalLogoWhite} alt="Mukti Hospital Logo" className="h-auto w-60 logo-white-filter" />
          </div>
          <div className="text-right text-xs">
            <p className="mb-1">+880 1601-666893</p>
            <p className="mb-1">muktihospitalpvtlimited@gmail.com</p>
            <p>https://muktihospital.com</p>
          </div>
        </div>

        {/* Content */}
        <div className="px-[20mm] content-wrapper">
           <div className="pt-[110px] pb-[90px]">
               <h1 className="mb-6 text-center text-2xl font-bold text-[#323290] underline">{title}</h1>
            {billInfo && (
              <div className="mb-6 flex justify-between text-base">
                {billInfo}
              </div>
            )} 
             {table && <table>{table}</table>}
              {summary && (
              <div className="flex justify-end">
                <div className="w-[50%] summary-container">
                  {summary}
                </div>
              </div>
              )}
            <div className="clear-both"></div>
            <div className="w-1/2">
                {note}
              </div>
            {footer && (
              <div className="flex justify-end mt-24">
                {footer}
              </div>
            )}
           </div>
        </div>
        
        {/* Footer */}
        <div className="absolute bottom-0 left-0 right-0">
          <div className="relative bg-[#e8f0ed] p-3 px-[20mm] print-bg-force">
            <div className="footer-shape print-bg-force"></div>
            <div className="relative z-10 grid grid-cols-2 gap-x-5 gap-y-1 text-[10pt] text-gray-800">
              <p className="flex items-center gap-2"><FaPhoneAlt size={10} /> <span>+880 1601-666893</span></p>
              <p className="flex items-center gap-2"><FaMapMarkerAlt size={10} /> <span>Race Course, Sasongacha, Cumilla</span></p>
              <p className="flex items-center gap-2"><FaEnvelope size={10} /> <span>muktihospitalpvtlimited@gmail.com</span></p>
              <p className="flex items-center gap-2"><FaGlobe size={10} /> <span>https://muktihospital.com</span></p>
            </div>
          </div>
          <div className="flex items-center justify-between bg-gray-800 p-2 px-[20mm] text-[10pt] text-white print-bg-force">
            <p>Software Powered By: Microters</p>
            <div className="flex items-center gap-4">
              <Link href="https://microters.com/" className="flex items-center gap-1.5">
                <FaGlobe size={10}/> https://microters.com
              </Link>
              <p className="flex items-center gap-1.5"><FaPhoneAlt size={10}/> +880 162-519-2766</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
